module.exports = {
  url: {
    api: `http://localhost:8000`,
    login: `http://localhost:8080`,
    main: `http://localhost:8080`,
    dashboard: `http://localhost:8080`,
    cdn: `http://localhost/cdn`
  },
  cookiedomain: "localhost",

  rules: {
    required: [v => !!v || "Required field!"],
    name: [
      v => !!v || "Required field!",
      value => (value && !(value.length > 100)) || "Maximum 100 characters"
    ],
    email: [
      v => !!v || "Email address is not valid!",
      v => /.+@.+\..+/.test(v) || "Invalid email address!"
    ],
    phonenumber: [
      v => !!v || "Phone number is not valid!",
      v =>
        /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(v) ||
        "Invalid phone number!"
    ],
    number: [
      v => !!v || "This field is required",
      v => /^\d+(\.\d+)?$/.test(v) || "Please enter a valid number"
    ]
  },
  regex: {
    name: /^[a-zA-Z -]{2,50}$/,
    mail: /^.+@.+$/,
    phonenumber: /^\+?[1-9]\d{3,14}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!#%*?&]{8,64}$/
  },
  allowedredirectdomains: [
    "localhost:8080",
    "localhost:8081",
    "localhost:8082",
    "localhost:8083",
    "localhost:8084",
    "localhost:8085",
    "localhost:8086"
  ],
  dateformat: {
    weekday: "short",
    year: "numeric",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric"
  }
};
